import React from 'react'
import { Route } from 'react-router-dom'
import * as Sentry from '@sentry/react'
import Breadcrumb from 'src/components/Breadcrumb'
import ContentHeader from 'src/components/ContentHeader'
import styles from '../components/Breadcrumb/breadcrumb.module.scss'

export class ContentRoute extends React.Component {
    state = {
        Component: null,
        refreshData: false,
    }

    loadRoute(routeName) {
        import(`${routeName}`)
            .then(module => {
                this.setState({ Component: module.default })
                localStorage.setItem('import-fail-count', '0')
            })
            .catch(ex => {
                Sentry.captureException(ex)
                console.error(ex)
                const failCount =
                    parseInt(localStorage.getItem('import-fail-count'), 10) || 0
                if (failCount > 2) {
                    throw ex
                }
                // Reload the current page when a chunk fails to load.
                // This can happen when a deploy created a new build, and a certain chunk don't match or doesn't exist anymore. Resulting in a syntax error.
                localStorage.setItem('import-fail-count', failCount + 1)
                window.location.reload()
            })
        return null
    }

    render() {
        const { component, path, breadcrumbs } = this.props
        const Component = this.state.Component
        return (
            <Route
                path={path}
                exact
                render={routeProps => {
                    // Check if we are on a route rendering a graph or list view to add an extra wrapper class,
                    // to allow specific styling for that route.
                    return (
                        <>
                            <div className={styles.breadcrumbHeaderWrapper}>
                                <Breadcrumb
                                    breadcrumbs={breadcrumbs}
                                    path={path}
                                    {...routeProps}
                                />
                                <ContentHeader
                                    onRefreshData={(dataNeedsRefresh, e) =>
                                        this.setState(
                                            state =>
                                                (state.refreshData =
                                                    dataNeedsRefresh)
                                        )
                                    }
                                    onPollData={this.pollData}
                                    {...this.props}
                                />
                            </div>
                            {Component ? (
                                <Component
                                    path={path}
                                    routeName={this.props.name}
                                    {...routeProps}
                                />
                            ) : (
                                this.loadRoute(component)
                            )}
                        </>
                    )
                }}
            />
        )
    }
}
